<template>
  <base-modal ref="modal">
    <base-card shadow>
      <h3 class="tw-text-xl tw-font-thin">Reactivate Plan</h3>
      <div class="tw-mt-5">
        <div class="tw-text-gray-800 tw-font-normal">Are you sure you want to reactivate this plan?</div>
        <div class="tw-text-gray-500 tw-text-sm">
          <span>The {{ organization.customerLabelSingular }} will be charged immediately and the plan will be restarted.</span
          ><span v-if="organization.useCreditsSetting === true" class="tw-ml-1"
            >Any credits already earned will be reactivated and new credits for the first billing cycle will be added to the account.</span
          >
        </div>
      </div>
      <base-form ref="form" v-model="isFormValid" class="tw-mt-5">
        <base-credit-card-input class="tw-mt-3" ref="creditCardInput" hide-name hide-postal-code />
      </base-form>
      <div class="sm:tw-flex sm:tw-flex-row-reverse tw-mt-4">
        <base-button @click="reactivatePlan" :loading="isLoading" class="tw-w-full sm:tw-w-auto sm:tw-ml-3">Reactivate Plan</base-button>
        <base-button @click="hide" type="flat" class="tw-w-full sm:tw-w-auto tw-mt-2 sm:tw-mt-0">
          Cancel
        </base-button>
      </div>
      <inline-error id="reactivate-business-member-plan-modal-error" :title="errorTitle" :message="errorMessage" :error="error" />
    </base-card>
  </base-modal>
</template>

<script>
import { mapGetters } from "vuex";
import InlineError from "@/components/InlineError";

export default {
  name: "BusinessMemberPlanReactivate",
  components: { InlineError },
  props: {
    businessId: String,
    userBusinessPlanId: String,
  },
  data: function() {
    return {
      isFormValid: true,
      stripeToken: null,
      isLoading: false,
      errorTitle: "",
      errorMessage: "",
      error: null,
    };
  },
  computed: {
    ...mapGetters("organization", ["organization"]),
  },
  methods: {
    show() {
      this.$refs.creditCardInput.reset();
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    },
    async reactivatePlan() {
      this.isLoading = true;
      this.stripeToken = await this.$refs.creditCardInput.createToken();

      if (!this.$refs.form.validate() || !this.stripeToken) return;

      this.$axios
        .post(`/businesses/${this.businessId}/members/${this.userId}/memberplans/${this.userBusinessPlanId}/reactivate`, {
          tokenId: this.stripeToken.id,
        })
        .then(() => {
          this.EventBus.$emit("member_update");
          this.EventBus.$emit("GLOBAL_NOTIFY", { title: "Member Plan Reactivated", message: "Plan was reactivated successfully" });
          this.hide();
        })
        .catch((err) => {
          this.errorTitle = "Error reactivating plan";
          this.errorMessage = "Sorry, we had trouble reactivating this plan. The technicians have been notified. Please try again.";
          this.error = err;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
